/*
 * @Description: 入口
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 10:33:09
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-12 17:38:09
 */
import React ,{ useEffect , useState }from 'react';
import { Switch, HashRouter as Router, Route, Redirect } from 'react-router-dom' ;
import { IndexPage, CityPage } from './page' ;
import './App.scss';

const App = ()  =>{
  const [page, setPage] = useState(false);
  useEffect(() => {
    let flag =  window.location.href.indexOf('maincity') ;
    if(flag !== -1){
      setPage(true) ;
    }
  },[]) ;
  
  return (
    <div className="App">
      <div className={!page ? "app-content-top" :"app-content-top app-content-top-maincity"}></div>
      <div className="app-content-main">
        <Router>
          <Switch>
            <Route exact path="/" component={IndexPage}></Route>
            <Route exact path="/maincity:id" component={CityPage}></Route>
            {/* <Redirect to="/" component={IndexPage}></Redirect> */}
          </Switch>
        </Router>
      </div>
      <div className={!page ? "app-content-bottom" : "app-content-bottom app-content-bottom-maincity"}>
        <div className="cloud-left"></div>
        <div className="cloud-right"></div>
        <div className="flower-bottom"></div>
      </div>
    </div>
  );
}

export default App;
